import type { UserRole } from '@xdocs/schemas';

/**
 * Resolves the CURRENT viewer's platform RBAC role (`users.role`,
 * F68/§15.2) so moderator-only entry points (F69 takedown on a share/
 * comment) are shown ONLY to staff — "enforcement is server-side
 * fail-closed, entry points only reflect role" (F69 AC, E15).
 *
 * OPEN ISSUE (returned in this task's issues list): `AuthState`
 * (`apps/web/src/auth/AuthProvider.tsx`, out of this task's ownership)
 * exposes only `userId`/`status`/`accessToken` — there is no `role` on it,
 * and no `user.get`/session-shaped WS op exists in the frozen M3
 * `op-contracts.ts` to fetch the viewer's own `users.role` either (E17
 * §5.2 says "tier + role read once at handshake and cached on the socket",
 * but that cache isn't surfaced to React anywhere yet). Until the auth/
 * session owner adds one of those, this always resolves `null`, which
 * fail-closed HIDES every moderator-only control here for every viewer —
 * including real moderators/admins on this build. That is a
 * discoverability regression for staff, NEVER a security hole: every
 * `moderation.takedown` call is re-authorized server-side
 * (`requireModerationTarget`) regardless of what this hook returns
 * (CODE_GUIDELINES §15: "No UI-only auth/ACL gates").
 *
 * Kept as its own self-contained hook (rather than inlined per call site)
 * so wiring the real source is a one-line change in exactly one place once
 * it exists.
 */
export function useViewerRole(): UserRole | null {
  return null;
}
